import { cn, DataTableContainer } from 'ui';

export const OrderTabContent = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <DataTableContainer className={cn('mt-4', className)}>
      {children}
    </DataTableContainer>
  );
};
